import { ValidationError } from '@framework/validation';
import React from 'react';
import { IEngineSectionStatus } from './SectionStatusSchema';

/**
 * Contiene:
 * 1. Le informazioni di stato così come registrate all'interno del Form
 * 2. Gli errori di validazione della sezione
 */
type SectionBody = Record<string, IEngineSectionStatus & { errors: any[] }>;

export interface IRuntimeSectionsStatusMonitorContext {
  errors: ValidationError[];
  sections: SectionBody;
}

export const RuntimeSectionsStatusMonitorContext =
  React.createContext<IRuntimeSectionsStatusMonitorContext>({
    errors: [],
    sections: {},
  });

export const useRuntimeSectionsStatusMonitorContext = () =>
  React.useContext(RuntimeSectionsStatusMonitorContext);

/**
 * Ritorna le informazioni di stato di una sezione.
 */
export function useRuntimeSectionStatus(sectionId: string) {
  const context = useRuntimeSectionsStatusMonitorContext();
  return (
    context.sections[sectionId] ?? { opened: false, touched: false, errors: [] }
  );
}
